import { Component, OnInit } from '@angular/core';
import { ConteudoService } from '@core/services/conteudo.service';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-dash-news',
  templateUrl: './dash-news.component.html',
  styleUrls: ['./dash-news.component.scss']
})


export class DashNewsComponent implements OnInit {

  noticias = [];
  slidesNoticias = [];

  constructor(private _conteudoService: ConteudoService) { }

  ngOnInit(): void {
    this._conteudoService.buscarNoticiasHome()
      .pipe(
        switchMap(resultado =>
          Array.isArray(resultado)
            ? this._conteudoService.buscarConteudosComImagens(resultado)
            : of([])
        )
      )
      .subscribe(noticias => {
        this.noticias = noticias;
        this.slidesNoticias = this.agruparNoticias(this.noticias, 2);
      });
  }

  private agruparNoticias(noticias: any[], tamanhoGrupo: number) {
    const grupos = [];
    for (let i = 0; i < noticias.length; i += tamanhoGrupo) {
      grupos.push(noticias.slice(i, i + tamanhoGrupo));
    }
    return grupos;
  }
}
